import mitt from 'mitt'
const MittUtils = mitt()
export default MittUtils